module.exports = __webpack_public_path__ + "img/GC-logo.d2c20b3a.png";